// Generated by CoffeeScript 2.7.0
var TextAreaMixin;

export default TextAreaMixin = {
  methods: {
    userInput: function(event) {
      return this.valueChange(event.target.value);
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      return this.value = entry.value;
    },
    _focus: function() {
      return this.$refs.input.focus();
    }
  }
};
